import { useSuspenseQuery } from "@tanstack/react-query";
import i18n from "@/lib/i18n";
import axios from "axios";

export enum TranslationKey {
  Translations = "translations",
}

export type AvailableLanguages = "uz" | "en" | "ru";

export function useTranslationLoader(locale: AvailableLanguages) {
  return useSuspenseQuery({
    queryKey: [TranslationKey.Translations, locale],
    queryFn: async () => {
      const { data } = await axios.get<{ result: [key: string, string] }>(
        `${import.meta.env.VITE_APP_TRANSLATION_URL}locale_${locale}.json`
      );
      if (!i18n.hasResourceBundle(locale, "translation")) {
        i18n.addResourceBundle(locale, "translation", data);
      }

      return data;
    },
    staleTime: 10 * 60 * 1000, // 10 minutes
  });
}
